import { useQuery } from "@tanstack/react-query";
import { ApiGetUserInfo } from "@/api";
import { useUserStore } from "@/store/useUserStore";
import { getToken } from "@/lib/auth";
import { normalizeUserInfo } from "@/lib/normalizeUserInfo";

export const useGetUserInfo = () => {
  const { setUserInfo } = useUserStore();
  return useQuery({
    queryKey: ["getUserInfo"],
    queryFn: async () => {
      const res = await ApiGetUserInfo();
      if (res.data) {
        setUserInfo(normalizeUserInfo(res.data));
      }
      return res.data ? normalizeUserInfo(res.data) : undefined;
    },
    refetchInterval: 1000 * 5,
    // 启动拉取 userInfo，须用 token；其余 Query 统一用 userInfo?.uid
    enabled: !!getToken(),
  });
};
